import { render, staticRenderFns } from "./PictureText.vue?vue&type=template&id=e3214884&scoped=true"
var script = {}
import style0 from "./PictureText.vue?vue&type=style&index=0&id=e3214884&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3214884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3214884')) {
      api.createRecord('e3214884', component.options)
    } else {
      api.reload('e3214884', component.options)
    }
    module.hot.accept("./PictureText.vue?vue&type=template&id=e3214884&scoped=true", function () {
      api.rerender('e3214884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/institutional-trading/components/PictureText.vue"
export default component.exports